export const BUILD_VERSION = '1783523579';
